import React, { Fragment } from 'react'
import Forgot from '../Components/Login/Forgot' 
function userForgot() {
  return (
    <div className="resources">
        <Forgot />
    </div>
  )
}

export default userForgot